import * as React from 'react';

interface AISuggestMenuIconProps {
  style?: React.CSSProperties;
  className?: string;
}

const SparkleIcon: React.FC = () => (
  <svg
    width={15}
    height={16}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <path
      d="M6 4C6 7.31371 8.68629 10 12 10C8.68629 10 6 12.6863 6 16C6 12.6863 3.31371 10 0 10C3.31371 10 6 7.31371 6 4Z"
      fill="white"
    />
    <path
      d="M12 0C12 1.65685 13.3431 3 15 3C13.3431 3 12 4.34315 12 6C12 4.34315 10.6569 3 9 3C10.6569 3 12 1.65685 12 0Z"
      fill="white"
    />
  </svg>
);

const AISuggestMenuIcon: React.FC<AISuggestMenuIconProps> = ({
  style,
  className
}) => (
  <div
    style={{
      padding: '4px',
      background: 'linear-gradient(47deg, #02FFEE 10%, #308CFF 42%, #D153FF 100%)',
      borderRadius: '4px',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: '2px',
      display: 'inline-flex',
      ...style
    }}
    className={className}
  >
    <SparkleIcon />
    <div
      style={{
        color: 'white',
        fontSize: '10px',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
        fontWeight: '500',
        wordWrap: 'break-word',
        lineHeight: '1'
      }}
    >
      AI
    </div>
  </div>
);

export default AISuggestMenuIcon;

